import { motion } from "framer-motion";
import { GALLERY } from "../../data/site";
import { Reveal, Kicker } from "./Reveal";

export const Gallery = () => (
  <section id="gallery" className="bg-ffc-light py-24 lg:py-32" data-testid="gallery">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Reveal><Kicker>Before & After</Kicker></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display mt-4 max-w-2xl text-4xl font-extrabold sm:text-5xl lg:text-6xl">
              The proof is in the finish.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-ffc-gray">
            A look at recent Charlotte projects — feature walls, custom shelving,
            kitchen &amp; bath, painting &amp; drywall, outdoor projects, commercial work and more.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
        {GALLERY.map((g, i) => (
          <motion.div key={g.cat + i}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
            className={`group relative hover-zoom overflow-hidden rounded-2xl break-inside-avoid ${g.aspect || (i % 5 === 0 ? "aspect-[4/5]" : i % 3 === 0 ? "aspect-[4/3]" : "aspect-square")}`}
            data-testid={`gallery-item-${i}`}>
            <img src={g.img} alt={g.alt || `${g.cat} project in Charlotte, NC by Fast Fix Charlotte`} loading="lazy" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ffc-ink/80 via-transparent to-transparent opacity-80" />
            <div className="absolute bottom-0 left-0 flex items-center gap-2 p-5">
              <span className="h-2 w-2 rounded-full bg-ffc-red" />
              <span className="font-display text-lg font-bold text-white">{g.cat}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
